// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as PreviewRouteImport } from './routes/preview'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as PlaygroundIndexRouteImport } from './routes/playground/index'
import { Route as PlaygroundDatatableRouteImport } from './routes/playground/datatable'
import { Route as PlaygroundQuerybuilderRouteImport } from './routes/playground/querybuilder'
import { Route as PlaygroundSchemaformRouteImport } from './routes/playground/schemaform'
import { Route as WorkIndexRouteImport } from './routes/work.index'
import { Route as WorkIndianContextRouteImport } from './routes/work.indian-context'
import { Route as WorkMyClinicRouteImport } from './routes/work.my-clinic'
import { Route as WorkPackcraftIndiaRouteImport } from './routes/work.packcraft-india'
import { Route as WorkVetnestRouteImport } from './routes/work.vetnest'
import { Route as BlogCategoryIndexRouteImport } from './routes/blog/$category/index'
import { Route as BlogCategorySlugRouteImport } from './routes/blog/$category/$slug'
import { Route as BlogTagIndexRouteImport } from './routes/blog/tag/index'
import { Route as BlogTagTagRouteImport } from './routes/blog/tag/$tag'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const PreviewRoute = PreviewRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const PlaygroundIndexRoute = PlaygroundIndexRouteImport.update({
            id: '/playground/',path: '/playground/',getParentRoute: () => rootRouteImport
          })
const PlaygroundDatatableRoute = PlaygroundDatatableRouteImport.update({
            id: '/playground/datatable',path: '/playground/datatable',getParentRoute: () => rootRouteImport
          })
const PlaygroundQuerybuilderRoute = PlaygroundQuerybuilderRouteImport.update({
            id: '/playground/querybuilder',path: '/playground/querybuilder',getParentRoute: () => rootRouteImport
          })
const PlaygroundSchemaformRoute = PlaygroundSchemaformRouteImport.update({
            id: '/playground/schemaform',path: '/playground/schemaform',getParentRoute: () => rootRouteImport
          })
const WorkIndexRoute = WorkIndexRouteImport.update({
            id: '/work/',path: '/work/',getParentRoute: () => rootRouteImport
          })
const WorkIndianContextRoute = WorkIndianContextRouteImport.update({
            id: '/work/indian-context',path: '/work/indian-context',getParentRoute: () => rootRouteImport
          })
const WorkMyClinicRoute = WorkMyClinicRouteImport.update({
            id: '/work/my-clinic',path: '/work/my-clinic',getParentRoute: () => rootRouteImport
          })
const WorkPackcraftIndiaRoute = WorkPackcraftIndiaRouteImport.update({
            id: '/work/packcraft-india',path: '/work/packcraft-india',getParentRoute: () => rootRouteImport
          })
const WorkVetnestRoute = WorkVetnestRouteImport.update({
            id: '/work/vetnest',path: '/work/vetnest',getParentRoute: () => rootRouteImport
          })
const BlogCategoryIndexRoute = BlogCategoryIndexRouteImport.update({
            id: '/blog/$category/',path: '/blog/$category/',getParentRoute: () => rootRouteImport
          })
const BlogCategorySlugRoute = BlogCategorySlugRouteImport.update({
            id: '/blog/$category/$slug',path: '/blog/$category/$slug',getParentRoute: () => rootRouteImport
          })
const BlogTagIndexRoute = BlogTagIndexRouteImport.update({
            id: '/blog/tag/',path: '/blog/tag/',getParentRoute: () => rootRouteImport
          })
const BlogTagTagRoute = BlogTagTagRouteImport.update({
            id: '/blog/tag/$tag',path: '/blog/tag/$tag',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,PreviewRoute: PreviewRoute,PlaygroundDatatableRoute: PlaygroundDatatableRoute,PlaygroundQuerybuilderRoute: PlaygroundQuerybuilderRoute,PlaygroundSchemaformRoute: PlaygroundSchemaformRoute,WorkIndianContextRoute: WorkIndianContextRoute,WorkMyClinicRoute: WorkMyClinicRoute,WorkPackcraftIndiaRoute: WorkPackcraftIndiaRoute,WorkVetnestRoute: WorkVetnestRoute,BlogIndexRoute: BlogIndexRoute,PlaygroundIndexRoute: PlaygroundIndexRoute,WorkIndexRoute: WorkIndexRoute,BlogCategorySlugRoute: BlogCategorySlugRoute,BlogTagTagRoute: BlogTagTagRoute,BlogCategoryIndexRoute: BlogCategoryIndexRoute,BlogTagIndexRoute: BlogTagIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)